// Mirrors POST /projects/settings-history and /global-data/settings-history
// (.../api/projects/settings_history.py): who changed how a project, or global data, is
// set up, newest first, a page at a time.
import { useInfiniteQuery } from "react-query";

import { QK } from "../queryKeys";
import { useAgentsHttp } from "../useAgentsHttp";

export interface ConfigChange {
  change_id: string;
  area: "drive" | "gmail" | "slack" | "agents" | "project" | "files";
  action: string;
  summary: string;
  detail: Record<string, unknown>;
  // The signed-in person; null when an agent made the change.
  actor_email: string | null;
  actor_agent: string | null;
  run_id: string | null;
  at: string;
}

interface SettingsHistoryPage {
  changes: ConfigChange[];
  more: boolean;
}

/** A project's history, or "global" for global data's. */
export type HistoryScope = { projectId: string } | "global";

export const useSettingsHistory = (scope: HistoryScope | null) => {
  const http = useAgentsHttp();
  const key = scope === "global" ? "global" : (scope?.projectId ?? null);
  return useInfiniteQuery<SettingsHistoryPage>(
    [QK.settingsHistory, scope === "global" ? "global" : "project", key],
    ({ pageParam }) =>
      scope === "global"
        ? http<SettingsHistoryPage>("/global-data/settings-history", {
            ...(pageParam ? { after_change: pageParam } : {}),
          })
        : http<SettingsHistoryPage>("/projects/settings-history", {
            project_id: key,
            ...(pageParam ? { after_change: pageParam } : {}),
          }),
    {
      enabled: !!key,
      getNextPageParam: (last) =>
        last.more ? last.changes[last.changes.length - 1]?.change_id : undefined,
    },
  );
};
